import { MessageService } from "primeng/api";
import { CartService } from "../cartService/cart.service";
import { Injectable } from "@angular/core";
@Injectable({
    providedIn: 'root',
  })
export class NotificationService {
    constructor(private messageService: MessageService, private cartService: CartService) {
      this.cartService.cartMessage$.subscribe((message: string) => {
        // Lorsque le message change, on l'affiche avec le service MessageService
        this.messageService.add({ severity: 'info', summary: 'AfriCereal', detail: message });
      });
    }
  }